import contactInfo_en from './contact-info_en.json'
import overviewWidget_en from './overview-widget_en.json'

const oak_us_resources = {
  en: {
    ...contactInfo_en,
    ...overviewWidget_en,
  },
}

export default oak_us_resources
